/* eslint-disable react/require-default-props */
import moment from 'moment';
import React from 'react';
import FavoriteButton from 'components/atoms/favorite_button';
import BiddingContactList from 'components/atoms/bidding_contact_list';
import CardCounter from 'components/atoms/card_counter';
import SelectButton from 'components/atoms/select_button';
import { Container } from './styles';
import BiddingViewedContactList from '../bidding_viewed_contact_list';
import VisualizeButton from '../visualize_button';

interface BiddingHeaderProps {
  bidding_updated: string;
  biddingId: string;
  biddingIndex: number;
  isChecked: boolean;
  isFavorited: boolean;
  isViewed?: boolean;
  isViewedBy?: Array<string>;
  source?: string;
  contactList: Array<string>;
  toggleSelected: (id: number, updateAll?: boolean) => void;
  favoritedSource: string;
  bulletinFilterId?: number;
}

const BiddingHeader: React.FC<BiddingHeaderProps> = (props: BiddingHeaderProps) => {
  const {
    bidding_updated,
    biddingId,
    biddingIndex,
    isChecked,
    isFavorited,
    isViewed = false,
    isViewedBy,
    source = 'biddings',
    contactList,
    favoritedSource,
    toggleSelected,
    bulletinFilterId = 0,
  } = props;

  return (
    <Container>
      <div
        className={`card-header bidding-bg-header bidding-info ${
          (source === 'management' || source === 'imminence') && 'rounded-top'
        }`}
      >
        <div className="row align-items-center">
          {(source === 'biddings' ||
            source === 'bulletin' ||
            source === 'share' ||
            source === 'favorited') && <CardCounter count={biddingIndex + 1} />}
          <div className="bidding-item-header-buttons d-flex mb-2 mb-md-0 d-print-none">
            {(source === 'biddings' || source === 'bulletin' || source === 'favorited') && (
              <div
                className="position-relative databalloon tour-remove-favorites-select-one"
                aria-label="Selecionar licitação"
                data-balloon-pos="up"
              >
                <SelectButton
                  id={parseInt(biddingId, 10)}
                  isChecked={isChecked}
                  toggleSelected={toggleSelected}
                  text=""
                />
              </div>
            )}
            {source !== 'share' && (
              <FavoriteButton
                biddingId={biddingId}
                isFavorited={isFavorited}
                favoritedSource={favoritedSource}
                bulletinFilterId={bulletinFilterId}
                source={source}
              />
            )}
          </div>

          {source !== 'share' && contactList && <BiddingContactList contactList={contactList} />}
          {source === 'bulletin' && (
            <div className="m-0 d-flex align-items-center">
              <VisualizeButton
                biddingId={biddingId}
                isViewed={isViewed}
                bulletinFilterId={bulletinFilterId}
              />
              {isViewedBy && isViewedBy.length > 0 && (
                <BiddingViewedContactList contactList={isViewedBy} />
              )}
            </div>
          )}
          <div className="ml-md-auto ml-2 text-white mr-2">
            <span className="font-weight-bold mr-2">Atualizada em</span>
            <span>{moment(bidding_updated).format('L LT')}</span>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default BiddingHeader;
